import { ReactElement, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, useHistory, Redirect } from "react-router-dom";
import { DependencyProvider, useDependency } from "./contexts/DependencyContext";
import { LoginService } from "./services/LoginService";
import PrivateRoute from "./components/Routing/PrivateRoute";
import DashboardPage from "./pages/DashboardPage";
import ComponentsPage from "./pages/ComponentsPage";
import LoginPage from "./pages/LoginPage";
import MapPage from "./pages/MapPage";
import Spinner from "./components/Shared/Spinner";
import Header from "./components/Layout/Header";
import SubHeader from "./components/Layout/SubHeader";
import "./stylesheets/main.scss";
import NotFoundPage from "./pages/NotFoundPage";

const App = (): ReactElement =>
{
    const [loading, setLoading] = useState<boolean>(true);
    const [subHeaderVisible, setSubHeaderVisibility] = useState<boolean>(false);

    const loginService = useDependency(LoginService);
    const history = useHistory();

    useEffect(() =>
    {
        loginService
            .loginFromSession()
            .catch(() => setLoading(false))
            .then(() => setLoading(false));
    }, [loginService, history]);

    return (
        <DependencyProvider>
            {!loading && (
                <div className="appWrapper">
                    <Router>
                        <Header subHeaderVisible={subHeaderVisible} toggleSubHeader={setSubHeaderVisibility} />
                        <SubHeader visible={subHeaderVisible} />
                        <Switch>
                            <Route exact path="/login" component={LoginPage} />
                            <PrivateRoute path="/map" component={MapPage} />
                            <PrivateRoute path="/components" component={ComponentsPage} />
                            <PrivateRoute path="/dashboard/:componentId?" component={DashboardPage} />
                            <Route exact path="/"><Redirect to="/dashboard/" /></Route>
                            <Route path="/404" component={NotFoundPage} />
                            <Redirect to="/404" />
                        </Switch>
                    </Router>
                </div>
            )}

            {loading && (
                <div className="fixed-fullscreen-spinner">
                    <Spinner />
                </div>
            )}
        </DependencyProvider>
    );
};

export default App;
